const CoverBg = () => {
    return <div className="cover-bg"></div>
}

export default CoverBg;